export const buildVars = {
	"version": "3.1.0",
	"build": "16361",
	"angularVersion": "22.2.2",
	"nxVersion": "23.3.0",
	"commitId": "9aff518fdc",
	"commitTime": "2026-11-04 16:03:40 +0000",
	"branch": "CON-player-insight-unpublish"
};
